// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DetailedEventTooltip--wrapper--Jv23t {
  width: 255px;
  padding: 8px 4px;
  box-sizing: border-box;
  position: relative;
}

.DetailedEventTooltip--row--aAvkb {
  line-height: 16px;
  font-weight: 500;
  color: var(--blue50);
  text-align: left;
}

.DetailedEventTooltip--image--yCYyY img {
  display: inline-block;
  max-width: calc(100% - 8px);
  height: auto;
  margin-bottom: 16px;
  padding: 0 4px;
}

.DetailedEventTooltip--eventTitle--zebDB {
  font-weight: 900;
  margin-bottom: 8px;
}

.DetailedEventTooltip--eventDescription--KHPpR {
}
`, "",{"version":3,"sources":["webpack://./src/components/daily/eventtooltip/DetailedEventTooltip.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;AAEA","sourcesContent":[".wrapper {\n  width: 255px;\n  padding: 8px 4px;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.row {\n  composes: smallSize from '../../../styles/typography.css';\n  line-height: 16px;\n  font-weight: 500;\n  color: var(--blue50);\n  text-align: left;\n}\n\n.image img {\n  display: inline-block;\n  max-width: calc(100% - 8px);\n  height: auto;\n  margin-bottom: 16px;\n  padding: 0 4px;\n}\n\n.eventTitle {\n  composes: row;\n  font-weight: 900;\n  margin-bottom: 8px;\n}\n\n.eventDescription {\n  composes: row;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `DetailedEventTooltip--wrapper--Jv23t`,
	"row": `DetailedEventTooltip--row--aAvkb ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"image": `DetailedEventTooltip--image--yCYyY`,
	"eventTitle": `DetailedEventTooltip--eventTitle--zebDB DetailedEventTooltip--row--aAvkb ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"eventDescription": `DetailedEventTooltip--eventDescription--KHPpR DetailedEventTooltip--row--aAvkb ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`
};
export default ___CSS_LOADER_EXPORT___;
